'use strict';

const React = require( 'react' );
const propTypes = require('prop-types');
const Tracker = require( '../../../../../_plugins/lib/tracker.js' );
const { object, string } = propTypes;
const createReactClass = require('create-react-class');

const TerminalSelect = createReactClass({
  propTypes: {
    location: string,
    locations: object.isRequired,
    name: string,
    emptyOption: string,
    className: string
  },

  getDefaultProps( ) {
    return {
      name: 'terminal',
      locations: {},
      emptyOption: 'Don\'t know'
    };
  },

  makeOption( key, val ) {
    return ( <option key={key} value={val}>{key}</option> );
  },

  makeOptions( ) {
    const { location, locations } = this.props;
    if ( !locations.terminals || !locations.terminals[location] ) return false;
    const terminalHtml = Object.keys( locations.terminals[location] ).map( ( key ) => {
      const item = locations.terminals[location][key];
      return this.makeOption( key, item );
    } );
    return terminalHtml;
  },

  changeOption( e ) {
    const { value } = e.target;
    Tracker.track( 'terminal_dropdown', value );
  },

  render() {
    const { className, name, emptyOption } = this.props;
    const terminals = this.makeOptions( );
    if ( !terminals ) return null;

    return (
      <select name={name} onChange={this.changeOption} className='form-control' ><option>{emptyOption}</option>{terminals}</select>
    );
  }
});

module.exports = TerminalSelect;





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/engines/terminal-dropdown.jsx